import { createBrowserRouter } from 'react-router';

const router = createBrowserRouter([
  {
    path: '/',
    async lazy() {
      const component = await import('./app/index');
      return { Component: component.default };
    },
  },
  {
    path: '/privacy-policy',
    async lazy() {
      const component = await import('./app/privacy-policy');
      return { Component: component.default };
    },
  },
  {
    path: '/terms-of-service',
    async lazy() {
      const component = await import('./app/terms-of-service');
      return { Component: component.default };
    },
  },
  {
    path: '/delete-account',
    async lazy() {
      const component = await import('./app/delete-account');
      return { Component: component.default };
    },
  },
  {
    path: '/join-us',
    async lazy() {
      const component = await import('./app/join-us');
      return { Component: component.default };
    },
  },
  {
    path: '*',
    async lazy() {
      const component = await import('./app/404');
      return { Component: component.default };
    },
  },
]);

export default router;
